module.exports = __webpack_public_path__ + "static/media/anc7kz.5f537e5d.pdf";